import * as React from "react";
const SvgShow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#show_svg__a)">
      <path d="M23.27 9.418C21.72 6.892 18.193 2.654 12 2.654S2.28 6.892.729 9.418a4.91 4.91 0 0 0 0 5.162c1.55 2.526 5.079 6.764 11.27 6.764 6.193 0 9.72-4.238 11.272-6.764a4.91 4.91 0 0 0 0-5.162m-1.704 4.115C20.234 15.7 17.219 19.344 12 19.344s-8.234-3.645-9.566-5.81a2.92 2.92 0 0 1 0-3.069C3.766 8.3 6.78 4.655 12 4.655s8.234 3.64 9.566 5.81a2.92 2.92 0 0 1 0 3.068" />
      <path d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 8a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15" />
    </g>
    <defs>
      <clipPath id="show_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShow;
